const ENV = process.env.NODE_ENV;
if (ENV !== 'production' &&
    ENV !== 'test' &&
    typeof console !== 'undefined' &&
    console.warn &&
    typeof window !== 'undefined') {
    // tslint:disable-next-line:no-console
    console.warn('You are using a whole package of cf-ui-mobile, ' +
        'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
}
export { default as Button } from './button/index';
export { default as Badge } from './badge/index';
export { default as Carousel } from './carousel/index';
export { default as Icon } from './icon/index';
export { default as Modal } from './modal/index';
export { default as NoticeBar } from './notice-bar/index';
export { default as Toast } from './toast/index';
export { default as Drawer } from './drawer/index';
export { default as PhotoPreview } from './photo-preview/index';
export { default as Progress } from './progress/index';
export { default as SelectArrow } from './select-arrow/index';
export { default as SelectItem } from './select-item/index';
export { default as Steps } from './steps/index';
export { default as ScrollToTop } from './scroll-to-top/index';
export { default as Tabs } from './tabs/index';
export { default as Checkbox } from './checkbox/index';
export { default as Radio } from './radio/index';
export { default as Rating } from './rating/index';
export { default as Collapse } from './collapse/index';
export { default as InputNumber } from './input-number/index';
export { default as InputSearch } from './input-search/index';
export { default as InputItem } from './input-item/index';
export { default as InputKeyBoard } from './input-key-board/index';
export { default as InputVerifyCode } from './input-verify-code/index';
export { default as LoadingPlaceholder } from './loading-placeholder/index';
export { default as ListScrollLoad } from './list-scroll-load/index';
export { default as LazyImg } from './lazy-img/index';
export { default as VideoBox } from './video-box/index';
export { default as NoMore } from './no-more/index';
export { default as NoThingBear } from './no-thing-bear/index';
export { default as Avatar } from './avatar/index';
export { default as SwipeAction } from './swipe-action/index';
export { default as WaterFall } from './water-fall/index';



// WEBPACK FOOTER //
// ./components/index.tsx